<template>
  <v-card v-if="this.appBar" tile flat class="result-text theme-title transparent appbar-result-action">
    {{ Number.isInteger(this.period_scores.first_period_scores.team_a) ? this.period_scores.first_period_scores.team_a : "-" }}
    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
    {{ Number.isInteger(this.period_scores.first_period_scores.team_b) ? this.period_scores.first_period_scores.team_b : "-" }}

    <span class="set-divider theme-text"> | </span>

    {{ Number.isInteger(this.period_scores.second_period_scores.team_a) ? this.period_scores.second_period_scores.team_a : "-" }}
    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
    {{ Number.isInteger(this.period_scores.second_period_scores.team_b) ? this.period_scores.second_period_scores.team_b : "-" }}

    <span class="set-divider theme-text"> | </span>

    {{ Number.isInteger(this.period_scores.final_period_scores.team_a) ? this.period_scores.final_period_scores.team_a : "-" }}
    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
    {{ Number.isInteger(this.period_scores.final_period_scores.team_b) ? this.period_scores.final_period_scores.team_b : "-" }}
  </v-card>

  <v-card v-else tile flat class="result-text theme-title transparent main-result">
        <span v-if="periodInt < 3">
            <span v-if="this.isMirrored">
                {{ Number.isInteger(this.period_scores.first_period_scores.team_b) ? this.period_scores.first_period_scores.team_b : 0 }}
                    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
                {{ Number.isInteger(this.period_scores.first_period_scores.team_a) ? this.period_scores.first_period_scores.team_a : 0 }}
            </span>
            <span v-else>
                {{ Number.isInteger(this.period_scores.first_period_scores.team_a) ? this.period_scores.first_period_scores.team_a : 0 }}
                    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
                {{ Number.isInteger(this.period_scores.first_period_scores.team_b) ? this.period_scores.first_period_scores.team_b : 0 }}
            </span>
        </span>

    <span v-if="periodInt >= 3 && periodInt < 12">
            <span v-if="this.isMirrored">
                {{ Number.isInteger(this.period_scores.second_period_scores.team_b) ? this.period_scores.second_period_scores.team_b : 0 }}
                    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
                {{ Number.isInteger(this.period_scores.second_period_scores.team_a) ? this.period_scores.second_period_scores.team_a : 0 }}
            </span>
            <span v-else>
                {{ Number.isInteger(this.period_scores.second_period_scores.team_a) ? this.period_scores.second_period_scores.team_a : 0 }}
                    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
                {{ Number.isInteger(this.period_scores.second_period_scores.team_b) ? this.period_scores.second_period_scores.team_b : 0 }}
            </span>
        </span>

    <span v-if="periodInt >= 12">
            <span v-if="this.isMirrored">
                {{ Number.isInteger(this.period_scores.final_period_scores.team_b) ? this.period_scores.final_period_scores.team_b : 0 }}
                    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
                {{ Number.isInteger(this.period_scores.final_period_scores.team_a) ? this.period_scores.final_period_scores.team_a : 0 }}
            </span>
            <span v-else>
                {{ Number.isInteger(this.period_scores.final_period_scores.team_a) ? this.period_scores.final_period_scores.team_a : 0 }}
                    <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
                {{ Number.isInteger(this.period_scores.final_period_scores.team_b) ? this.period_scores.final_period_scores.team_b : 0 }}
            </span>
        </span>
  </v-card>
</template>

<script>
/* STRAND - TeamScores - src/components/strand/TeamScores.vue */
import CONSTANTS from '@/constants';
import { mapState } from 'vuex';

export default {
  name: "TeamScores",
  props: {
    gamedata: Object,
    appBar: Boolean,
    isMirrored: Boolean
  },
  data() {
    return {
      // timelineData törölve
      singleScoreActions: [],
      doubleScoreActions: [],
      period_scores: {
        first_period_scores: { team_a: null, team_b: null },
        second_period_scores: { team_a: null, team_b: null },
        final_period_scores: { team_a: null, team_b: null }
      }
    }
  },
  computed: {
    // Vuex Store bekötése
    ...mapState('game', ['timelineData', 'currentPeriod']),

    periodInt() {
      return parseInt(this.currentPeriod);
    }
  },
  watch: {
    // Ha változik az adat a store-ban, újraszámolunk
    timelineData: {
      handler() {
        this.calculateTeamScores();
      },
      deep: true
    },
    // Ha változik a periódus a store-ban, újraszámolunk (bár itt az összes periódust egyszerre számoljuk, nem árt)
    currentPeriod() {
      this.calculateTeamScores();
    }
  },
  methods: {
    calculateTeamScores() {
      let self = this;
      // Nullázás
      self.period_scores = {
        first_period_scores: { team_a: 0, team_b: 0 },
        second_period_scores: { team_a: 0, team_b: 0 },
        final_period_scores: { team_a: 0, team_b: 0 }
      }

      if(self.timelineData) {
        self.timelineData.forEach(function(item) {
          let action = item.params && item.params.selectedAction && item.params.selectedAction.actionId ? item.params.selectedAction.actionId : item.action;
          let selectedTeam = item.params && item.params.selectedTeamId ? item.params.selectedTeamId : null;
          let increaseScoreBy = self.doubleScoreActions.includes(action) ? 2 : self.singleScoreActions.includes(action) ? 1 : 0;

          if(!item.deleted) {
            switch (parseInt(item.period)) {
              case 1:
                self.period_scores.first_period_scores.team_a += (selectedTeam === "teamA" ? increaseScoreBy : 0);
                self.period_scores.first_period_scores.team_b += (selectedTeam === "teamB" ? increaseScoreBy : 0);
                break;
              case 3:
                self.period_scores.second_period_scores.team_a += (selectedTeam === "teamA" ? increaseScoreBy : 0);
                self.period_scores.second_period_scores.team_b += (selectedTeam === "teamB" ? increaseScoreBy : 0);
                break;
              case 12:
                self.period_scores.final_period_scores.team_a += (selectedTeam === "teamA" ? increaseScoreBy : 0);
                self.period_scores.final_period_scores.team_b += (selectedTeam === "teamB" ? increaseScoreBy : 0);
                break;
            }
          }
        });
      }
    },
  },
  mounted() {
    this.singleScoreActions = CONSTANTS.ACTIONS.SINGLE_SCORE_ACTIONS;
    this.doubleScoreActions = CONSTANTS.ACTIONS.DOUBLE_SCORE_ACTIONS;

    // Első számolás
    this.calculateTeamScores();
  },
}
</script>

<style scoped>
@font-face {
  font-family: TickingTimebombBB;
  src: url('~@/assets/TickingTimebombBB.otf') format("opentype");
}

.theme-title.result-text {
  white-space: nowrap;
  max-width: initial;
}

.main-result.result-text {
  min-width: 34px;
}

.appbar-result-action.result-text {
  font-family: TickingTimebombBB;
  font-size: 33px;
  font-style: normal;
  background: transparent;
}

.set-divider {
  font-family: monospace;
  display: inline-block;
  padding: 0;
  margin: 0;
}
</style>
